import { render } from "./IconDashboard.vue?vue&type=template&id=7e2b4389"
import script from "./IconDashboard.vue?vue&type=script&lang=ts"
export * from "./IconDashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script